import config from "config";
import { get } from "lodash";
import { history } from "main";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import React, { PropTypes } from "react";
import { Provider } from "react-redux";
import { Router } from "react-router";
import customTheme from "themes/custom";

const muiTheme = getMuiTheme(customTheme);

class AppContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    routerKey: PropTypes.number,
    store: PropTypes.object.isRequired,
  };
  componentDidMount() {
    console.log("this.prosss - AppContainer", this.props);
    // Handle navigate request from iframe (casa-web-app)
    window.addEventListener("message", function (event) {
      if (event.origin !== config.casaWebAppUrl) {
        return;
      }
      const navigateTo = get(event, "data.navigateTo");
      if (navigateTo) {
        history.push(navigateTo);
      }
    });
  }

  render() {
    const { history, routes, routerKey, store, keycloak } = this.props;
    return (
      // <keyCloakContext.Provider value={keycloak.token}>
      <Provider store={store}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <div style={{ height: "100%" }}>
            <Router
              history={history}
              children={routes}
              key={routerKey}
              keycloak={keycloak}
            />
          </div>
        </MuiThemeProvider>
      </Provider>
      // </keyCloakContext.Provider>
    );
  }
}

export default AppContainer;



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js